<template>
    <Card >
        <div class="align-start justify-content-between mx-1" :class="sm.direction">
            <div :class="sm.size">
                <div class="column">
                    <div class="d-flex">
                        <span class="caption">{{$t('support.tickets.id')}}</span>
                    </div>
                    <div class="d-flex">
                        <p class="font-weight-bold">{{ticket.identifier}}</p>
                    </div>
                </div>
            </div>
            <div :class="sm.size">
                <div class="column">
                    <div class="d-flex">
                        <span class="caption">{{$t('support.tickets.title')}}</span>
                    </div>
                    <div class="d-flex">
                        <p class="font-weight-bold">{{ticket.title}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="align-start justify-content-between mx-1" :class="sm.direction">
            <div :class="sm.size">
                <div class="column">
                    <div class="d-flex">
                        <span class="caption">{{$t('support.tickets.created_at')}}</span>
                    </div>
                    <div class="d-flex">
                        <p class="font-weight-bold">{{$moment(ticket.created_at).format('DD/MM/YYYY')}}</p>
                    </div>
                </div>
            </div>
            <div :class="sm.size">
                <div class="column">
                    <div class="d-flex">
                        <span class="caption">{{$t('support.tickets.status')}}</span>
                    </div>
                    <div class="d-flex">
                        <i :class="[status.icon, status.class]"></i>
                        <span class="status ml-1">{{status.name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-start mx-1 pt-3">
            <BaseButton type="block" @click="goTicket(ticket)">{{$t('support.tickets.view')}}</BaseButton>
        </div>
    </Card>
</template>

<script>
import Card from '../../argon/components/Cards/Card'
import Badge from '../../argon/components/Badge'
import BaseButton from '../../argon/components/BaseButton'
import ticket from './mixins/ticket';

export default {
    name: 'TicketMobile',
    components: {
        BaseButton,
        Badge,
        Card,
    },
    mixins: [
        ticket,
    ],
    props: {
        ticket: {
            type: Object,
            required: true
        }
    },
    methods: {
        goTicket({identifier}) {
            window.location.href = `/app/tickets/show/${identifier}`
        }
    },
    computed: {
        sm() {
            let sm = {}
            if (this.$mq === 'sm') {
                return sm = {
                    direction: 'column',
                    size: 'col-12'
                }
            }
            return sm = {
                direction: 'row',
                size: 'col-6'
            }
        },
    },
}
</script>

<style scoped>
.caption {
    text-transform: uppercase;
    font-size: 0.80rem
}
</style>
